import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import LegalInformationForm from './LegalInformationForm';
import { createLegalInformationData } from '../../api/api'
import {
    getLegalInformation,
    starGetLegalInformation,
    setLegalInformation
} from '../../actions/legalInformation';
import Loader from '../Loader';
import { pushToDataLayer } from '../../utils/gtmUtils';

export class LegalInformationPage extends React.Component {
    constructor(props) {
        super(props)
    }

    componentWillMount() {
        const self = this;
        this.props.starGetLegalInformation(this.props.beneficiaryData.idBeneficiaire, this.props.partenaireData.id).then((response) => {
            self.setState({ data: response.data });
            this.props.getLegalInformation(response.data, this.props.partenaireData.id);
        });
    }

    onSubmit = (legalInformationData) => {
        const dataLayer = {
            event: "legalInformationSave",
            url: window.location.href,
            idPartenaire: this.props.partenaireData.id
        }
        pushToDataLayer(dataLayer);

        legalInformationData.idBeneficiaire = this.props.beneficiaryData.idBeneficiaire;
        legalInformationData.testament = !!+legalInformationData.testament;
        legalInformationData.notary = !!+legalInformationData.notary;
        legalInformationData.dateCreation = this.props.legalInformationData.dateCreation;
        legalInformationData.dateModification =  this.props.legalInformationData.dateModification;
        if (!legalInformationData.testament)
            legalInformationData = { 
                testament: false, 
                id : legalInformationData.id,
                idBeneficiaire : legalInformationData.idBeneficiaire,
                dateCreation : this.props.legalInformationData.dateCreation,
                dateModification :  this.props.legalInformationData.dateModification
            }
        createLegalInformationData(legalInformationData, this.props.partenaireData.id).then(response => {
            this.props.setLegalInformation(legalInformationData);
            this.props.history.push('/accueil');
        }).catch(function (error) {
            console.log('error', error);
        });
    };

    goBack = (e) => {
        e.preventDefault();
        this.props.history.push('/accueil');
    }
    render() {
        return (
            <div className="assistance-agreement-page container main-container">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Accueil</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">Mes informations juridiques</li>
                </ol>
                <h1 className="text-center">Mes informations juridiques</h1>
                <div className="intro-text">
                    Afin que vos dernières volontés soient respectées, informez vos proches si vous avez rédigé un testament ; qu’il soit olographe (rédigé par vous-même) ou authentique (rédigé par un notaire).
                </div>

                {this.state && this.state.data ?
                    <LegalInformationForm
                        onSubmit={this.onSubmit}
                        data={this.state.data}
                        countryData={this.props.countryData}
                        back={this.goBack}
                    />
                    :
                    <Loader />
                }
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    starGetLegalInformation: (benefId, partnerId) => dispatch(starGetLegalInformation(benefId, partnerId)),
    getLegalInformation: (data, partnerId) => dispatch(getLegalInformation(data, partnerId)),
    setLegalInformation: (legalInformationData) => dispatch(setLegalInformation(legalInformationData))

});

const mapStateToProps = state => ({
    legalInformationData: state.legalInformationData,
    beneficiaryData: state.beneficiaryData.idBeneficiaire ? state.beneficiaryData : JSON.parse(sessionStorage.getItem('benef')),
    countryData: state.countryData,
    partenaireData: state.partenaireData
})


//export default connect()(LegalInformationPage);
export default connect(mapStateToProps, mapDispatchToProps)(LegalInformationPage);




// WEBPACK FOOTER //
// ./src/components/LegalInformationPage/LegalInformationPage.js